import { DataEntry } from "../../shared/data-entry.interface";
import { DataproviderService } from './../../dataprovider.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root" })
export class CoverConfiguratorService {
  private basicImgUrl: string = "../../../assets/img/frames/";
  private basicExt: string = ".png";

  constructor(private ds: DataproviderService) { }

  private getFinishingPath(): string {
    const finishing: DataEntry = this.ds.getFinishing();
    if (finishing.name_ref) {
      return finishing.name_ref;
    } else {
      return "";
    }
  }

  private getShapePath(): string {
    const shape: DataEntry = this.ds.getShape();
    if (shape && shape.name_ref) {
      return `-${shape.name_ref}/`;
    } else {
      return "/";
    }
  }

  public setExt(ext: string) {
    this.basicExt = ext;
  }

  public getPlateUrl(itemCode: string): string {
    let url = this.basicImgUrl
    url += this.getFinishingPath() + this.getShapePath() + itemCode + this.basicExt;
    return url;
  }

  public getSwitchUrl(switchNumber: number, nrOfButtons: number = 1): string {
    let url = this.basicImgUrl;

    if (nrOfButtons == 1) {
      url += this.getFinishingPath() + `-switch/switch-${switchNumber}${this.basicExt}`;
    } else {
      url += this.getFinishingPath() + `-switch/switches-${switchNumber}${this.basicExt}`;
    }
    
    return url;
  }
}